
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { FileText, ExternalLink, Mail, Shield, Wifi, Users, Settings } from 'lucide-react';

const AdminEmployeeLinksTab: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <div className="mb-6">
        <h2 className="text-xl font-semibold">Employee Links</h2>
        <p className="text-gray-600 mt-1">Quick access to employee tools and resources</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Button 
          onClick={() => window.open('https://outlook.office.com/mail/', '_blank')}
          className="h-20 flex flex-col items-center justify-center"
          variant="outline"
        >
          <Mail className="h-6 w-6 mb-2" />
          <span>Outlook</span>
        </Button>
        
        <Button 
          onClick={() => window.open('https://itmgmtsol.rmmservice.com', '_blank')}
          className="h-20 flex flex-col items-center justify-center"
          variant="outline"
        >
          <Settings className="h-6 w-6 mb-2" />
          <span>NinjaOne Portal</span>
        </Button>
        
        <Button 
          onClick={() => window.open('https://usea1-ninjaone.sentinelone.net/login', '_blank')}
          className="h-20 flex flex-col items-center justify-center"
          variant="outline"
        >
          <Shield className="h-6 w-6 mb-2" />
          <span>SentinelOne</span>
        </Button>
        
        <Button 
          onClick={() => window.open('https://unifi.ui.com/', '_blank')}
          className="h-20 flex flex-col items-center justify-center"
          variant="outline"
        >
          <Wifi className="h-6 w-6 mb-2" />
          <span>Unifi Site Manager</span>
        </Button>
        
        <Button 
          onClick={() => window.open('https://portal.itmgmtsol.com', '_blank')}
          className="h-20 flex flex-col items-center justify-center"
          variant="outline"
        >
          <Users className="h-6 w-6 mb-2" />
          <span>Employee Portal</span>
        </Button>
        
        <Button 
          onClick={() => navigate('/blog/generator')}
          className="h-20 flex flex-col items-center justify-center"
          variant="outline"
        >
          <FileText className="h-6 w-6 mb-2" />
          <span>Blog Generator</span>
        </Button>
      </div>
    </div>
  );
};

export default AdminEmployeeLinksTab;
